import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { TranslateService } from '@ngx-translate/core';
import { ForgetPasswordAction, SetAuthLoading } from '../store/auth.actions';
import { AuthService } from '../services/auth.service';
import { BASE_URL } from 'src/environments/environment';
import { emailValidator } from 'src/app/shared/validators/fields-validators';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
})
export class ForgetPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  isDropdownOpen = false;
  currentLanguage = '';
  currentYear: number = new Date().getFullYear();
  BASE_URL = BASE_URL;
  showDBOptions = false;
  databases: string[] = [];

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private translateService: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    localStorage.removeItem('currentUser');
    this.resetPasswordForm = this.fb.group({
      database: [''],
      email: ['', [Validators.required, emailValidator()]],
    });

    const savedLang = localStorage.getItem('lang') || 'en';
    this.translateService.use(savedLang);
    this.currentLanguage = savedLang;

    this.showDBOptions =
      ['127.0.0.1', 'localhost', 'qa-', 'preprod'].filter((value) =>
        window.location.host.includes(value)
      ).length > 0;
    this.getDBs();
  }

  switchLanguage(lang: string) {
    if (lang !== this.translateService.currentLang) {
      this.translateService.use(lang);
    }
    localStorage.setItem('lang', lang);
    this.currentLanguage = lang;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  requestPasswordReset(): boolean {
    if (!this.resetPasswordForm.valid) {
      this.resetPasswordForm.markAllAsTouched();
      return false;
    }
    this.store.dispatch(SetAuthLoading({ isLoading: true }));
    this.store.dispatch(ForgetPasswordAction({ payload: this.resetPasswordForm.value }));
    return true;
  }

  getDBs(): void {
    this.authService.getDBs().subscribe((res) => {
      this.databases = res.data;
      this.resetPasswordForm.patchValue({ database: this.databases[0] });
    });
  }
}
